import React from 'react';
import { useOutsideClick } from '../hook/useClickOutside';

const style = {
	padding: '10px',
	border: '1px solid grey',
	display: 'flex',
	justifyContent: 'space-between',
};

const UseClickOutsidePage = () => {
	const [count, setCount] = React.useState(0);

	const handleClickOutside = () => {
		setCount(0);
	};
	const ref = useOutsideClick(handleClickOutside);

	const handleHeaderClick = (event) => {
		event.stopPropagation();
	};

	const handleClick = () => {
		setCount((state) => state + 1);
	};
	return (
		<div
			className="mt-5 max-w-[900px] mx-auto items-center"
			style={style}
			onClick={handleHeaderClick}
		>
			<div className="text-md font-semibold hover:text-gray-500 cursor-pointer">
				Header
			</div>
			<button
				ref={ref}
				type="button"
				onClick={handleClick}
				className="bg-gray-300 text-black px-4 py-3 rounded-md"
			>
				Count: {count}
			</button>
		</div>
	);
};

export default UseClickOutsidePage;
